import { type RefrigerationUnit } from '@/data/schemas';
import type { RefrigerationUnitTechnicalInput } from '@/data/repos/refrigerationUnitsRepo';
import {
  buildVentilationDefaults,
  buildVentilationValues,
  ventilationToInput,
} from './ventilationFields';
import {
  buildAbatementSystemDefaults,
  buildAbatementSystemValues,
  abatementSystemToInput,
} from './abatementSystemFields';
import { buildDischargeDefaults, buildDischargeValues, dischargeToInput } from './dischargeFields';
import type { RefrigerationUnitFormValues } from './shared';

/**
 * Combined defaults for Abbattimento & Scarico subtab.
 * Includes: Scrubber, Sistema di abbattimento, Collettori VS, Vasca
 */
export const buildAbbattimentoCombinedDefaults = (): Partial<RefrigerationUnitFormValues> => ({
  ...buildVentilationDefaults(),
  ...buildAbatementSystemDefaults(),
  ...buildDischargeDefaults(),
});

/**
 * Combined values extractor for Abbattimento & Scarico subtab.
 */
export const buildAbbattimentoCombinedValues = (
  refrigerationUnit: RefrigerationUnit
): Partial<RefrigerationUnitFormValues> => ({
  ...buildVentilationValues(refrigerationUnit),
  ...buildAbatementSystemValues(refrigerationUnit),
  ...buildDischargeValues(refrigerationUnit),
});

/**
 * Combined input converter for Abbattimento & Scarico subtab.
 */
export const abbattimentoCombinedToInput = (
  values: RefrigerationUnitFormValues
): Pick<
  NonNullable<RefrigerationUnitTechnicalInput['safety']>,
  'scrubber' | 'abatementSystem' | 'vsRelief' | 'abatementTank' | 'vvfDocs' | 'vvfDocsLocation'
> => {
  const { scrubber } = ventilationToInput(values);
  const { abatementSystem } = abatementSystemToInput(values);
  const { vsRelief, abatementTank, vvfDocs, vvfDocsLocation } = dischargeToInput(values);

  return {
    scrubber,
    abatementSystem,
    vsRelief,
    abatementTank,
    vvfDocs,
    vvfDocsLocation,
  };
};
